"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATAudioScene = void 0;
const ATSceneNames_1 = require("./ATSceneNames");
const KHAudioScene_1 = require("./KH/KHAudioScene");
class ATAudioScene extends KHAudioScene_1.KHGenericAudioScene {
    constructor() {
        super(ATSceneNames_1.default.Audio);
        ATAudioScene.Shared = this;
    }
    getSfxInfo() {
        return ATAudioScene.sfxClips();
    }
    static sfxClips() {
        return [
            {
                key: "click",
                asset: {
                    loadKey: "click",
                    url: "assets/switch_007.wav",
                }
            }, {
                key: "buzzer",
                asset: {
                    loadKey: "buzzer",
                    url: "assets/buzzer.wav",
                }
            },
        ];
    }
}
exports.ATAudioScene = ATAudioScene;
